import React, { useState } from 'react';
import { IconCalculator, IconTrendingDown, IconCheck } from '@tabler/icons-react';
export function SavingsCalculator() {
  const [turnovers, setTurnovers] = useState<number>(20);
  // Cost assumptions
  const standardCostPerTurnover = 45;
  const cleanAiCostPerTurnover = 30;
  const monthlyStandardCost = turnovers * standardCostPerTurnover;
  const monthlyCleanAiCost = turnovers * cleanAiCostPerTurnover;
  const monthlySavings = monthlyStandardCost - monthlyCleanAiCost;
  const yearlySavings = monthlySavings * 12;
  return <section className="w-full py-20 md:py-24 px-5" style={{
    background: '#002CA5'
  }} data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        {/* Section header — centered on blue */}
        <div className="text-center mb-12" data-id="element-216">
          <div className="flex justify-center mb-4" data-id="element-217">
            <span className="inline-flex items-center gap-2 border border-[#69DCFF] text-[#69DCFF] rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest" data-id="element-218">
              <IconCalculator size={16} data-id="element-219" />
              Calcola il risparmio
            </span>
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4" data-id="element-220">
            Calcola il vantaggio degli{' '}
            <span style={{
            color: '#FF4081'
          }} data-id="element-221">
              interventi in sharing.
            </span>
          </h2>

          <div className="flex justify-center mt-4" data-id="element-222">
            <div style={{
            width: '40px',
            height: '3px',
            background: '#FF4081',
            borderRadius: '2px'
          }} data-id="element-223" />
          </div>

          <p className="font-body text-base md:text-lg mt-4 max-w-2xl mx-auto leading-relaxed" style={{
          color: 'rgba(255,255,255,0.7)'
        }} data-id="element-224">
            Inserisci i tuoi dati e scopri quanto risparmi ogni mese con
            CleanAI. Più host nella tua zona, più i costi si dividono — a parità
            di qualità.
          </p>
        </div>

        {/* White card container */}
        <div className="bg-white rounded-none p-8 md:p-12" data-id="element-225">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-226">
            {/* Left Column: Controls */}
            <div data-id="element-227">
              <div className="bg-[#F5F7FA] p-6 md:p-8 rounded-none border border-gray-100" data-id="element-228">
                <div className="flex justify-between items-end mb-4" data-id="element-229">
                  <label htmlFor="turnovers-slider" className="font-heading font-semibold text-navy text-lg" data-id="element-230">
                    Turnover mensili totali
                  </label>
                  <span className="font-heading font-bold text-3xl text-navy" data-id="element-231">
                    {turnovers}
                  </span>
                </div>

                <input id="turnovers-slider" type="range" min="5" max="100" step="5" value={turnovers} onChange={e => setTurnovers(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-accent-pink mb-6" style={{
                accentColor: '#FF4081'
              }} data-id="element-232" />

                <div className="flex justify-between text-sm text-body-gray font-body" data-id="element-233">
                  <span data-id="element-234">5 (Piccolo Host)</span>
                  <span data-id="element-235">100+ (Property Manager)</span>
                </div>
              </div>
            </div>

            {/* Right Column: Results Card */}
            <div className="bg-[#F5F7FA] rounded-none p-8 md:p-10 relative overflow-hidden border-2 border-gray-100" data-id="element-236">
              <h3 className="font-heading text-xl font-semibold mb-8 text-navy" data-id="element-237">
                Stima dei costi mensili
              </h3>

              <div className="space-y-6 relative z-10" data-id="element-238">
                {/* Standard Cost */}
                <div className="flex justify-between items-center pb-6 border-b border-gray-200" data-id="element-239">
                  <div data-id="element-240">
                    <div className="text-body-gray text-sm font-body mb-1" data-id="element-241">
                      Metodo Tradizionale
                    </div>
                    <div className="text-xs text-body-gray/60 font-body" data-id="element-242">
                      ~€45 ad intervento
                    </div>
                  </div>
                  <div className="font-heading text-2xl text-body-gray line-through decoration-gray-300" data-id="element-243">
                    €{monthlyStandardCost.toLocaleString('it-IT')}
                  </div>
                </div>

                {/* CleanAI Cost */}
                <div className="flex justify-between items-center pb-6 border-b border-gray-200" data-id="element-244">
                  <div data-id="element-245">
                    <div className="font-body font-bold mb-1 flex items-center gap-2 text-[20px]" style={{
                    color: '#002CA5'
                  }} data-id="element-246">
                      <IconCheck size={16} data-id="element-247" />
                      Con CleanAI
                    </div>
                    <div className="text-xs text-body-gray/60 font-body" data-id="element-248">
                      ~€30 ad intervento (in sharing)
                    </div>
                  </div>
                  <div className="font-heading text-3xl font-bold text-navy" data-id="element-249">
                    €{monthlyCleanAiCost.toLocaleString('it-IT')}
                  </div>
                </div>

                {/* Savings Highlight */}
                <div className="pt-4" data-id="element-250">
                  <div className="text-body-gray text-sm font-body mb-2" data-id="element-251">
                    Il tuo risparmio stimato
                  </div>
                  <div className="flex items-baseline gap-3" data-id="element-252">
                    <span className="font-heading text-5xl md:text-6xl font-bold" style={{
                    color: '#FF4081'
                  }} data-id="element-253">
                      €{monthlySavings.toLocaleString('it-IT')}
                    </span>
                    <span className="text-body-gray font-body" data-id="element-254">/mese</span>
                  </div>

                  <div className="mt-4 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-body font-medium" style={{
                  background: '#E8F0FE',
                  color: '#002CA5'
                }} data-id="element-255">
                    <IconTrendingDown size={18} data-id="element-256" />
                    Risparmi €{yearlySavings.toLocaleString('it-IT')} all'anno
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}